const state = {
    ReadQR: false,
    loading: false,
    dataTicket: null,
    background: false,
    ticket: false,
    messages: {
        visible: false,
        text: "Por favor espere un momento",
        color: "orange",
        icon: "mdi-plus",
    },
    sendMessage: false,
};
const mutations = {
    sendMessage(state, payload) {
        state.background = payload;
        state.sendMessage = payload;
    },
    ReadQR(state, payload) {
        state.background = payload;
        state.ReadQR = payload;
    },
    closed(state) {
        state.sendMessage = false;
        state.ReadQR = false;
        state.background = false;
        state.ticket = false;
    },
    loading(state, payload) {
        state.loading = payload;
    },
    dataTicket(state, payload) {
        state.dataTicket = payload;
        state.background = true;
        state.ticket = true;
    },
    changeClient(state, name) {
        state.dataTicket.clientNames = name;
    },
    changePrice(state, price) {
        state.dataTicket.servicePrice = price;
    },
    messages(state, payload) {
        // state.background = payload.visible;
        state.messages = payload;
    },

};
const getters = {
    background: (state) => state.background,
    ticket: (state) => state.ticket,
    loading: (state) => state.loading,
    dataTicket: (state) => state.dataTicket,
    messages: (state) => state.messages,
    ReadQR: (state) => state.ReadQR,
    sendMessage: (state) => state.sendMessage,
};

const actions = {
    goLink({ }, url) {
        window.open(url, '_blank');
    }
};
export default {
    state,
    getters,
    mutations,
    actions
};